import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CancellationComponent } from './pages/cancellation/cancellation.component';
import { LoginWithOtpComponent } from './shared/login-with-otp/login-with-otp.component';
import { OtpDemoComponent } from './pages/otp-demo/otp-demo.component';
import { MyBookings } from './pages/my-bookings/my-bookings';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { BookingSearchComponent } from './pages/booking-search/booking-search';
import { BookingDetails } from './pages/booking-details/booking-details';
import { RazorpayResponse } from './pages/razorpay-response/razorpay-response';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'home', component: Home },
  { path: 'login-otp', component: LoginWithOtpComponent },
  { path: 'otp-demo', component: OtpDemoComponent },
  { path: 'my-bookings', component: MyBookings },
  { path: 'my-profile', component: MyProfileComponent },
  { path: 'booking-search', component: BookingSearchComponent },
  { path: 'booking-details', component: BookingDetails },
  { path: 'terms', component: TermsComponent },
  { path: 'cancellation', component: CancellationComponent },
  { path: 'privacy', component: PrivacyComponent },
  {
    path: 'booking-success/:s/:d',
    component: RazorpayResponse
  },
];
